import { Grid, Typography, Box } from '@mui/material';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import { MobileInput } from '../MobileInput/MobileInput';
import { CustomInput } from '../CustomInput/CustomInput';
import { CustomSelect } from '../CustomSelect/CustomSelect';
import { ContactInformationStyles as classes } from './ContactInformationStyles';
import { dgiMapping } from '../../../services/dgiMapping';
import { dgiContMapping } from '../../../services/dgiContMapping';
import {
  CONTACT_DISCLAIMER,
  LAST_NAME,
  LETS_START_SUB_HEAD,
  FIRST_NAME,
  REQUIRED,
  EMAIL,
  MOBILE,
  ACC_OPENEING_DGI_HEAD,
  ACC_OPENEING_HEAD,
  PREFERRED_CONTACT_TIME,
  ELITE_ACCOUNT_EN,
} from '../../../constants';
import Layout from '../../Layout';
import RetailImage1 from '../../../images/Retail_Image_1.png';
import EliteImage from '../../../images/EliteAccImg1.png';
import { productMapping } from '../../../services/productMapping';
import SaveAppContactInfo from '../../SaveApp/SaveAppContactInfo';
import {
  isBundle,
  isCDIraproduct,
  isCDproduct,
  isIRAEducativaProduct,
  isSimilarIRAProducts,
} from '../../commonCode';
import NewLayout from '../../Bundle/NewLayout';

function Contact(props) {
  const { t } = useTranslation();
  const leadGenerationContext = useContext(LeadGenerationContext);
  const {
    contactInformation,
    contactInformationErrors,
    setFirstName,
    location,
    idUploadStatus,
    productName,
    isModalSaveLater,
  } = leadGenerationContext;
  const { handleChange, isValidating, handleContinue, handleBack } = props;

  let content = {};
  const isCDFlow = isCDproduct(productName);
  const productHeading = () => {
    if (
      dgiMapping(leadGenerationContext.productName) === 'DGI Contribution' ||
      dgiContMapping(leadGenerationContext.productName)
    ) {
      content = {
        headingid: 'screenOneHeading',
        ariaDescribedbyId: 'screenOneDesc',
        descriptionKey: 'Account Opening Text DGICont',
        descriptionValue: ACC_OPENEING_DGI_HEAD,
      };
    } else
      content = {
        headingid: 'screenOneHeading',
        ariaDescribedbyId: 'screenOneDesc',
        descriptionKey: 'Account Opening Text',
        descriptionValue: ACC_OPENEING_HEAD,
      };

    return content;
  };

  const mainLayout = () => (
    <Layout
      ariaDescribedby="screenOneHeading"
      headingId={productHeading().headingid}
      ariaDescribedbyId={productHeading().ariaDescribedbyId}
      classes={classes}
      descriptionKey={productHeading().descriptionKey}
      descriptionValue={productHeading().descriptionValue}
      stepValue={
        isCDFlow || isCDIraproduct(productName) || isIRAEducativaProduct(productName) ? 0 : 1
      }
      handleContinue={handleContinue}
      handleBack={
        isCDFlow || isCDIraproduct(productName) || isIRAEducativaProduct(productName)
          ? handleBack
          : null
      }
      // handleSaveApplication={isCDFlow ? handleSaveApplication : null}
      disableCondition={isValidating}
      // backBtnTestid="back_button_id"
      continueBtnTestid="handleBtn_id"
      screenLoading={isValidating}
      layoutImage={
        productMapping(productName) === ELITE_ACCOUNT_EN ||
        productMapping(productName) === 'Ahorra' ||
        isSimilarIRAProducts(productName)
          ? EliteImage
          : RetailImage1
      }
    >
      {contactInfoContent()}
      {isModalSaveLater && (
        <SaveAppContactInfo openModal={isModalSaveLater} currentPage="contact-info" />
      )}
    </Layout>
  );

  const contactInfoContent = () => (
    <Box sx={classes.contact_grid_margin}>
      <Grid container sx={classes.contact_container} spacing={0} data-page="contact-info">
        <Grid
          container
          role="region"
          aria-labelledby="letsStartheading"
          aria-describedby="contactDisclaimerId"
        >
          <Grid container size={{ xs: 12 }}>
            <Typography
              sx={classes.contact_heading}
              id="letsStartheading"
              variant="h2"
              aria-label={t(LETS_START_SUB_HEAD, {
                defaultValue: LETS_START_SUB_HEAD,
              })}
            >
              {t(LETS_START_SUB_HEAD, {
                defaultValue: LETS_START_SUB_HEAD,
              })}
            </Typography>
          </Grid>

          <Grid container sx={[classes.inputs_grid_margin, classes.margin_adjust_for_top_grid]}>
            <Grid size={{ xs: 12, md: 6 }} sx={classes.gridStyles}>
              <CustomInput
                id="firstName"
                dataTestId="firstName_id"
                required
                inputLabelAriaLabel={`${t(FIRST_NAME, {
                  defaultValue: FIRST_NAME,
                })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
                label={t(FIRST_NAME, { defaultValue: FIRST_NAME })}
                autoFocus
                handleChange={handleChange}
                disabled={!!idUploadStatus}
                placeholder={t('Enter First Name', {
                  defaultValue: 'Enter First Name',
                })}
                fullWidth
                handleBlur={() =>
                  setFirstName(contactInformation?.firstName ? contactInformation.firstName : '')
                }
                inputProps={{ maxLength: 10, 'data-testid': 'first-name' }}
                value={contactInformation?.firstName ? contactInformation.firstName : ''}
                error={
                  contactInformationErrors?.firstName ? contactInformationErrors.firstName : ''
                }
              />
              <Box
                component="span"
                sx={classes.error_message}
                role="alert"
                data-testid="first-name-error"
              >
                {t(contactInformationErrors?.firstName, {
                  defaultValue: contactInformationErrors?.firstName,
                })}
              </Box>
            </Grid>

            <Grid sx={classes.gridStyles} size={{ xs: 12, md: 6 }}>
              <CustomInput
                id="lastName"
                dataTestId="lastName_id"
                required
                inputLabelAriaLabel={`${t(LAST_NAME, {
                  defaultValue: LAST_NAME,
                })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
                label={t(LAST_NAME, { defaultValue: LAST_NAME })}
                handleChange={handleChange}
                disabled={
                  !!idUploadStatus ||
                  leadGenerationContext.isApplicationSaved ||
                  leadGenerationContext.savedDataFlow
                }
                placeholder={t('Enter Last Name', {
                  defaultValue: 'Enter Last Name',
                })}
                fullWidth
                inputProps={{ maxLength: 15, 'data-testid': 'last-name' }}
                value={contactInformation?.lastName ? contactInformation.lastName : ''}
                error={contactInformationErrors?.lastName ? contactInformationErrors.lastName : ''}
              />
              <Box
                component="span"
                sx={classes.error_message}
                role="alert"
                data-testid="last-name-error"
              >
                {t(contactInformationErrors?.lastName, {
                  defaultValue: contactInformationErrors?.lastName,
                })}
              </Box>
            </Grid>

            <Grid sx={classes.gridStyles} size={{ xs: 12, md: 6 }}>
              <CustomInput
                id="email"
                dataTestId="email_id"
                required
                disabled={
                  leadGenerationContext.savedDataFlow || leadGenerationContext.isApplicationSaved
                }
                inputLabelAriaLabel={`${t(EMAIL, {
                  defaultValue: EMAIL,
                })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
                label={t(EMAIL, {
                  defaultValue: EMAIL,
                })}
                handleChange={handleChange}
                placeholder={t('Enter Email Address', {
                  defaultValue: 'Enter Email Address',
                })}
                fullWidth
                inputProps={{ 'data-testid': 'email', maxLength: 40 }}
                value={contactInformation?.email ? contactInformation.email : ''}
                error={contactInformationErrors?.email ? contactInformationErrors.email : ''}
              />
              <Box
                component="span"
                role="alert"
                sx={classes.error_message}
                data-testid="email-error"
              >
                {t(contactInformationErrors?.email, {
                  defaultValue: contactInformationErrors?.email,
                })}
              </Box>
            </Grid>

            <Grid sx={classes.gridStyles} size={{ xs: 12, md: 6 }}>
              <MobileInput
                id="phone"
                dataTestId="phone_id"
                required
                ariaLabelForInputLabel={`${t(MOBILE, {
                  defaultValue: MOBILE,
                })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
                label={t(MOBILE, { defaultValue: MOBILE })}
                location={location || 'PR'}
                handleChange={handleChange}
                placeholder={t('Enter Mobile Number', {
                  defaultValue: 'Enter Mobile Number',
                })}
                fullWidth
                phoneValue={contactInformation?.phone ? contactInformation.phone : ''}
                maxLength={location && location === 'VI' ? 10 : 7}
                inputMode="numeric"
                phoneError={contactInformationErrors?.phone}
                maxLengthOfAreaCode={3}
                areaCodeInputMode="numeric"
                areaCodeAriaLabel={`${t('Area Code', {
                  defaultValue: 'Area Code',
                })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
                areaCodeId="areaCode"
                areaCode={contactInformation?.areaCode ? contactInformation.areaCode : ''}
                isBundle={isBundle(productName)}
              />
              {contactInformationErrors?.areaCode ? (
                <Box
                  component="span"
                  role="alert"
                  sx={classes.error_message}
                  data-testid="areacode-error"
                >
                  {t(contactInformationErrors?.areaCode, {
                    defaultValue: contactInformationErrors?.areaCode,
                  })}
                </Box>
              ) : (
                <Box
                  component="span"
                  role="alert"
                  sx={classes.error_message}
                  data-testid="phone-error"
                >
                  {t(contactInformationErrors?.phone, {
                    defaultValue: contactInformationErrors?.phone,
                  })}
                </Box>
              )}
            </Grid>

            <Grid sx={classes.gridStyles} size={{ xs: 12, md: 6 }}>
              <CustomSelect
                id="preferredContactTime"
                dataTestId="select_testid"
                required={false}
                inputLabelAriaLabel={`${t(PREFERRED_CONTACT_TIME, {
                  defaultValue: PREFERRED_CONTACT_TIME,
                })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
                label={t(PREFERRED_CONTACT_TIME, {
                  defaultValue: PREFERRED_CONTACT_TIME,
                })}
                options={['8:00 AM to 12:00 PM', '12:00 PM to 6:00 PM']}
                nsSeparator="|"
                handleChange={handleChange}
                fullWidth
                value={
                  contactInformation?.preferredContactTime
                    ? contactInformation.preferredContactTime
                    : ''
                }
                selectAriaLabel={`${t('Aria Label Preferred Contact Time', {
                  defaultValue:
                    'Preferred Contact Time Select Preferred Contact Time dropdown menu button',
                })} `}
              />
              <Box component="span" role="alert" sx={classes.error_message}>
                {t(contactInformationErrors?.preferredContactTime, {
                  defaultValue: contactInformationErrors?.preferredContactTime,
                })}
              </Box>
            </Grid>
          </Grid>

          <Grid container size={{ xs: 12 }} sx={classes.consent_message}>
            {/* {leadGenerationContext.productName === 'Consumer Credit' ? (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <img
                    src={InfoIcon}t
                    width="20px"
                    height="20px"
                    tabIndex="0"
                    alt="By selecting continue, you authorize us to communicate with you through calls, text messages and emails."
                  />
                  <Typography
                    id="contactDisclaimerId"
                    className={classes.contact_terms}
                    style={{ marginLeft: '13px' }}
                  >
                    {t(
                      'By selecting continue, you authorize us to communicate with you through calls, text messages and emails.',
                      {
                        defaultValue:
                          'By selecting continue, you authorize us to communicate with you through calls, text messages and emails.',
                      }
                    )}
                  </Typography>
                </div>
              ) : ( */}
            <Typography variant="subtitle1" id="contactDisclaimerId" sx={classes.contact_terms}>
              {t('ContactDisclaimer', {
                defaultValue: CONTACT_DISCLAIMER,
              })}
            </Typography>
            {/* )} */}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );

  const bundleLayoutContent = () => <NewLayout>{contactInfoContent()}</NewLayout>;

  return (
    <>
      {/* {bundleLayoutContent()} */}
      {mainLayout()}
    </>
  );
}

export default Contact;

Contact.propTypes = {
  handleChange: PropTypes.func,
  isValidating: PropTypes.bool,
  handleContinue: PropTypes.func,
  handleBack: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};
